var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('split-test',{attrs:{"type":"flag","name":_setup.FLAG_IMPRESSIONS_POSTS},scopedSlots:_vm._u([{key:"on",fn:function(){return [_c('track-impression',_vm._b({},'track-impression',_vm.$attrs,false),[_vm._t("default")],2)]},proxy:true},{key:"off",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }